import type { FC } from 'react'

import { SelectableCard, StyledText } from '@skytech/ui'
import LockOutlineIcon from 'mdi-react/LockOutlineIcon'

import { Translation } from '@/app/translations/Translation'
import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'

import { getCheckboxIcon } from './helpers'

import './styles.scss'

const PolicyTile: FC<{
  id: number
  name: string
  description: string
  maximumAmount: number
  customerHeadName: string
  vendorName: string
  coverAmount: number | null
  currency: string | null
  selectedPolicyIds: number[] | null
  isLocked?: boolean
  isMultipleChoice?: boolean
  onPolicySelect: (id: number) => void
}> = ({
  id,
  name,
  description,
  customerHeadName,
  vendorName,
  maximumAmount,
  currency,
  selectedPolicyIds,
  isLocked = false,
  isMultipleChoice,
  onPolicySelect,
}) => {
  const isSelected = Boolean(selectedPolicyIds?.includes(id))
  const Icon = getCheckboxIcon({ isSelected, isMultipleChoice })

  return (
    <div className="item-wrapper">
      <SelectableCard
        textLeft
        bordered
        padding={16}
        colorMode="yellow"
        className="item"
        disabled={isLocked}
        isSelected={isSelected}
        onClick={() => onPolicySelect(id)}
      >
        <h3>{name}</h3>
        <h4>{description}</h4>
        <h5>
          {customerHeadName ? <Translation id="Global" /> : <Translation id="Local" />},{' '}
          {vendorName}
        </h5>

        <h5 className="covered-amount">
          <Translation id="Maximum amount" />{' '}
          <StyledText>
            <FormattedNumberWithCurrency amount={maximumAmount || 0} currency={currency} />
          </StyledText>
        </h5>

        <div className="checkmark">{isLocked ? <LockOutlineIcon /> : <Icon />}</div>
      </SelectableCard>
    </div>
  )
}

export default PolicyTile
